import { isNil } from 'ramda';
import * as React from 'react';

import { IRoadInfoSchema } from '../../types';
import { isArrayWithItems, getDistanceHighway } from '../../utils/helpers';
import { RoadItem } from '../road_item';

export const getHighways = (regionHasRoads: boolean, roadInfoList: IRoadInfoSchema[], regionId?: number) => {
  if (!regionHasRoads || isNil(regionId)) {
    return null;
  }

  const road = isArrayWithItems(roadInfoList) && roadInfoList[0];
  if (!road) {
    return null;
  }

  return roadInfoList.map(item => {
    return (
      <RoadItem
        key={item.roadId}
        roadLink={item?.seo?.url ?? ''}
        roadName={item.name || ''}
        distance={getDistanceHighway(item, regionId)}
      />
    );
  });
};
